<template>
    <div class="relative h-full w-full">
        <div
            v-bind="attrs"
            :inert="blurred"
            class="h-full w-full"
            :class="{ 'pointer-events-none cursor-not-allowed opacity-10 blur-md': blurred }"
        >
            <slot />
        </div>

        <div v-if="blurred" class="bg-dark-base/70 absolute inset-0 h-full w-full">
            <div class="flex h-full w-full flex-col space-y-1">
                <div
                    v-if="title || $slots.title"
                    class="m-2 flex h-full grow items-center justify-center text-center align-middle"
                >
                    <slot name="title">
                        {{ title }}
                    </slot>
                </div>

                <hr
                    v-if="
                        (title || $slots.title) &&
                        (imagePath || $slots.image || text || $slots.text || buttonText || $slots.button)
                    "
                    class="border-dark-lightest m-2 rounded-lg"
                />

                <div
                    v-if="imagePath || $slots.image || text || $slots.text || buttonText || $slots.button"
                    class="h-26 w-full flex-none p-2"
                >
                    <div class="flex h-full w-full rounded-lg bg-white/40 p-2 backdrop-blur-xs">
                        <div
                            v-if="imagePath || $slots.image"
                            class="flex h-20 w-20 flex-none items-center justify-center p-1 text-center align-middle opacity-100"
                        >
                            <slot name="image">
                                <img
                                    :src="imagePath"
                                    class="cursor-pointer rounded-lg transition duration-200 hover:scale-102"
                                    alt="Mockup"
                                    @click="popupOpen = true"
                                />
                                <Popup v-model:is-open="popupOpen">
                                    <img :src="imagePath" class="rounded-lg" alt="Mockup" />
                                </Popup>
                            </slot>
                        </div>
                        <div class="flex h-full grow opacity-100">
                            <div
                                class="mx-4 flex w-full flex-col items-center justify-center space-y-2 text-center align-middle text-xs"
                            >
                                <div v-if="text || $slots.text" class="w-full">
                                    <slot name="text">
                                        {{ text }}
                                    </slot>
                                </div>
                                <div v-if="buttonText || $slots.button" class="w-full">
                                    <slot name="button">
                                        <Button
                                            small
                                            class="w-full"
                                            :action="buttonAction ? buttonAction : defaultButtonAction"
                                        >
                                            {{ buttonText }}
                                        </Button>
                                    </slot>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, useAttrs } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import Button from '@/components/buttons/Primary.vue'
import Popup from '@/components/Popup.vue'

const props = defineProps({
    blurred: { type: Boolean, default: false },
    title: { type: String, default: '' },
    imagePath: { type: String, default: '' },
    buttonAction: { type: Function },
    buttonText: { type: String, default: '' },
    text: { type: String, default: '' },
})

// Accessing undeclared attributes
const attrs = useAttrs()

// Set inheritAttrs to false to prevent attributes being automatically added to the root element
defineOptions({
    inheritAttrs: false,
})

const { t, locale } = useI18n()
const router = useRouter()

const popupOpen = ref(false)
const defaultButtonAction = () => {
    router.push({
        name: 'settings.subscription',
    })
}
</script>
